import { type LatLngTuple } from 'leaflet';

export const DEFAULT_COORDS: LatLngTuple = [35.69976, 51.33757];
